import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthProvider';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { CustomerProtectedRoute } from './components/auth/CustomerProtectedRoute';
import { MULTI_TENANT_ENABLED } from './config/features';
import LandingPage from './components/dashboard/LandingPage';
import AcademyPage from './components/academy/AcademyPage';
import { menuItemsUS } from './config/menuItems';
import './App.css';
import './components/academy/AcademyPage.css';
import './components/visualization/VisualizationPage.css';
import './components/visualization/VisualizationCanvas.css';
import './components/visualization/TreeFilterControls.css';
import './components/common/CameraImageViewer.css';
import './components/common/FilterPanel.css';
import './components/common/MonthSelector.css';
import './components/common/TimeRangeSelector.css';
import './components/common/VisualizationHeader.css';
import './components/admin/AdminUserPage.css';
import './components/floorplan-mapper/FloorplanMapperPage.css';
import './components/site-reporting/SiteReportingPage.css';

const pageComponents: Record<string, React.ComponentType> = {
  '/academy': AcademyPage,
  '/visualization': lazy(() => import('./components/visualization/VisualizationPage')),
  '/floorplan-mapper': lazy(() => import('./components/floorplan-mapper/FloorplanMapperPage')),
  '/admin': lazy(() => import('./components/admin/AdminUserPage')),
  '/site-reporting': lazy(() => import('./components/site-reporting/SiteReportingPage')),
};

function AppUS() {
  return (
    <AuthProvider>
      <Router>
        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><div className="spinner"></div></div>}>
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <LandingPage />
                </ProtectedRoute>
              }
            />
            {menuItemsUS.map(({ path, adminOnly }) => {
              const PageComponent = pageComponents[path];
              if (!PageComponent) return null;
              return (
                <Route
                  key={path}
                  path={path}
                  element={
                    <ProtectedRoute adminOnly={!!adminOnly}>
                      <PageComponent />
                    </ProtectedRoute>
                  }
                />
              );
            })}
            {MULTI_TENANT_ENABLED && (
              <Route
                path="/customer"
                element={
                  <CustomerProtectedRoute>
                    <LandingPage />
                  </CustomerProtectedRoute>
                }
              />
            )}
            {MULTI_TENANT_ENABLED && menuItemsUS.map(({ path }) => {
              const PageComponent = pageComponents[path];
              if (!PageComponent) return null;
              return (
                <Route
                  key={`customer${path}`}
                  path={`/customer${path}`}
                  element={
                    <CustomerProtectedRoute>
                      <PageComponent />
                    </CustomerProtectedRoute>
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </Router>
    </AuthProvider>
  );
}

export default AppUS;
